import { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { RxTextAlignJustify } from 'react-icons/rx'
import { FaPhone } from 'react-icons/fa6'
import { IoIosMail } from 'react-icons/io'

import { isTrue } from '../../../shared/utilities'

import FrontMenuItems from './FrontMenuItems'
import Image from '../Pure/Image.jsx'


const img_config =
{
	original: 1000,
	desktop: 1000,

	available: [500, 1000, 1500, 2000, 3000]
};


export default function FrontHeader (props)
{
	const [open, setOpen] = useState(false);
	const [sub_menu, setSubMenu] = useState();

	const location = useLocation();

	useEffect(function ()
	{
		setOpen(false);
		setSubMenu(undefined);
	},
	[location.pathname]);

	const toggleSideBar = useCallback(function (e)
	{
		setOpen(open => !isTrue(open));
	},
	[]);

	return (
		<header className="f-header">

			<div id="logo" className={ 'f-header__logo' + (open ? ' active ' : '') }>
				<a href="/">
					<Image src="/images/logo_fond_noir.png" alt="logo Sotraf" src_config={ img_config } />
				</a>
			</div>

			<button id="btn_menu" type="button" className="f-header__btn"
				onClick={ toggleSideBar }>
				<RxTextAlignJustify />
			</button>

			<div id="menu" className={ 'f-header__menu' + (open ? ' active' : '') }>

				<div id="logo" className="f-header__logo--menu">
					<a href="/">
						{
							open ?
							(
								<Image src="/images/logo.jpg" alt="logo" src_config={ img_config } />
							)
							:
							(
								<Image src="/images/logo_fond_noir.png" alt="logo" src_config={ img_config } />
							)
						}
						
					</a>
				</div>

				<nav className="f-header__nav">
					<FrontMenuItems />
				</nav>

				<div className='f-header__infos'>
					<div className="f-header__contact u-margin-bottom-15">
						<IoIosMail />
						<a href='mailto:contact@sotraf.fr'>
							contact@sotraf.fr

						</a>
					</div>

					<div className="f-header__contact">
						<FaPhone />
						<a href='tel:0562987574'>
							05 62 98 75 74
						</a>
					</div>
				</div>

			</div>

		</header>
	);
}